import { useContext, useEffect } from 'react';
import GlobalContext from '~/context/giveaway/GlobalContext';

const useNoScroll = () => {
  const { isSpinnerImmersive } = useContext(GlobalContext);

  useEffect(() => {
    if (isSpinnerImmersive) {
      document.body.classList.add('no-scroll', 'static');
    } else {
      document.body.classList.remove('no-scroll', 'static');
    }
  }, [isSpinnerImmersive]);
};

export default useNoScroll;
